import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class DoorSensorIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };
    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 300">
                <path
                    d="M292.61 300H161.17a7.39 7.39 0 0 1-7.39-7.39V7.39A7.39 7.39 0 0 1 161.17 0h131.44A7.39 7.39 0 0 1 300 7.39v285.22a7.39 7.39 0 0 1-7.39 7.39zm-124-14.79h116.6V14.79H168.57zM97.43 300h-90A7.39 7.39 0 0 1 0 292.61V97.24a7.39 7.39 0 0 1 7.39-7.39h90a7.39 7.39 0 0 1 7.39 7.39v195.37a7.39 7.39 0 0 1-7.35 7.39zm-82.64-14.79H90V104.63H14.79z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(DoorSensorIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/DoorSensorIcon.js